import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-14 md:py-20 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Anime%20style%20abstract%20background%20with%20warm%20orange%20and%20gold%20flowing%20energy%20waves%2C%20soft%20gradient%2C%20subtle%20ninja%20star%20pattern%2C%20atmospheric%20and%20calm%2C%20clean%20and%20modern%20minimalist%20design%2C%20warm%20tones&width=1800&height=600&seq=cta-naruto-bg&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-background-900/70"></div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-white mb-4">
          准备好开始你的忍者冒险了吗？
        </h2>
        <p className="text-sm md:text-base text-white/70 mb-8 leading-relaxed">
          立即加入火影同人游戏的世界，体验最精彩的忍者冒险故事。
          数百款精品火影同人游戏等你来探索，全部免费畅玩！
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/role-playing"
            className="px-8 py-3 bg-primary-500 text-white font-semibold rounded-full hover:bg-primary-600 transition-all duration-300 text-sm whitespace-nowrap no-underline cursor-pointer"
          >
            立即探索游戏
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 border-2 border-white/30 text-white font-semibold rounded-full hover:bg-white/10 hover:border-white/60 transition-all duration-300 text-sm whitespace-nowrap no-underline cursor-pointer"
          >
            关于我们
          </Link>
        </div>
      </div>
    </section>
  );
}